import apiClient from '@/lib/axios';
import type { Lead, ApiResponse, AssignLeadDto } from '../types';

/**
 * Assign a lead to an estimator with optional commission override
 *
 * @param leadId - The ID of the lead to assign
 * @param assignedToId - The ID of the user (estimator) to assign the lead to
 * @param commissionOverride - Optional commission rate override (as decimal 0-1, not percentage 0-100)
 * @returns The updated lead
 */
export const assignLead = async (
  leadId: number,
  assignedToId: number,
  commissionOverride?: number
): Promise<Lead> => {
  const dto: AssignLeadDto = {
    leadId,
    assignedToId,
    commissionOverride,
  };

  const response = await apiClient.post<ApiResponse<Lead>>(
    `/leads/${leadId}/assign`,
    dto
  );

  return response.data.data;
};
